import React, { useEffect } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  toast,
  ToastContainer,
  ToastItem,
  ToastPosition,
  TypeOptions,
} from 'react-toastify';

// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-toastify/dist/ReactToastify.css';
import { ReturnComponentType } from 'common';
import './NotifyComponent.scss';
import { useTypedDispatch } from 'hooks';
import { setError } from 'state/actions';

type NotifyComponentType = {
  message: string | string[];
  type: TypeOptions;
  delay?: number;
  isError?: boolean;
  location?: ToastPosition;
};
export const NotifyComponent = ({
  message,
  type,
  delay,
  isError = false,
  location = 'top-right',
}: NotifyComponentType): ReturnComponentType => {
  const dispatch = useTypedDispatch();

  const messages = typeof message === 'string' ? [message] : message;

  const notify = () =>
    toast(
      <span className="NotifyComponent">
        {messages.map((message, i) => {
          return (
            <span key={`notify_message_${new Date().getTime() * Math.random()}`}>
              {message}
              {i < messages.length - 1 && <br />}
            </span>
          );
        })}
      </span>,
      {
        position: location as ToastPosition,
        autoClose: isError ? false : delay || 3000,
        hideProgressBar: true,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
        type,
      },
    );

  const unsubscribe = toast.onChange(({ status }: ToastItem) => {
    if (isError && status === 'removed') {
      dispatch(setError(''));
    }
  });

  useEffect(() => {
    if (message) {
      notify();
    }

    return () => {
      unsubscribe();
    };
  }, [message]);

  return <ToastContainer />;
};
